import { render, staticRenderFns } from "./PushModel.vue?vue&type=template&id=5defd130&scoped=true"
import script from "./PushModel.vue?vue&type=script&lang=js"
export * from "./PushModel.vue?vue&type=script&lang=js"
import style0 from "./PushModel.vue?vue&type=style&index=0&id=5defd130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5defd130",
  null
  
)

export default component.exports